module.exports = __webpack_public_path__ + "static/media/kr.5adfd676.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/kr.svg
// module id = 1276
// module chunks = 0